import { createSelector } from 'reselect'

import { selectFeatureFlags } from 'common/redux/selectors/auth'

const selectAuth = state => state.auth

const selectAuthUser = createSelector(selectAuth, auth => (auth && auth.user) || {})
export const selectBrokerOpId = createSelector(selectAuthUser, user => user.broker_op_id || null)
export const selectIsTransitionBroker = createSelector(selectAuthUser, user => user.is_transition_broker || false)

export const selectNewBrokerPortalCashbackTerms = createSelector(
  selectFeatureFlags,
  feature_flags => _.get(feature_flags, "new_broker_portal_cashback_terms", false)
)

export const selectNewBrokerDashboardFlag = createSelector(
  selectFeatureFlags,
  flags => _.get(flags, "new_broker_portal_dashboard", false)
)

export const selectNewLeadsPageFlag = createSelector(
  selectFeatureFlags,
  flags => _.get(flags, "new_broker_leads_page", false)
)

export const selectEnableVIPDashboardFlag = createSelector(
  selectFeatureFlags,
  flags => _.get(flags, "enable_vip_dashboard", false)
)
